var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6ZM4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.6667C17.7909 12.6667 16 14.4576 16 16.6667C16 18.8759 17.7909 20.6667 20 20.6667C22.2091 20.6667 24 18.8759 24 16.6667C24 14.4576 22.2091 12.6667 20 12.6667ZM14 16.6667C14 13.353 16.6863 10.6667 20 10.6667C23.3137 10.6667 26 13.353 26 16.6667C26 19.9805 23.3137 22.6667 20 22.6667C16.6863 22.6667 14 19.9805 14 16.6667Z",
    fill: "#7E7E7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2788 27.6699C15.464 27.6699 13.9738 28.0213 12.9349 28.9246C11.9738 29.7602 11.729 30.4813 11.2274 31.9861L9.33008 31.3537C9.34199 31.318 9.35382 31.2824 9.36561 31.247C9.84719 29.8005 10.2415 28.6161 11.6226 27.4153C13.1018 26.1292 15.0935 25.6699 16.2788 25.6699H23.7788C25.5067 25.6699 26.9842 26.154 28.4349 27.4153C29.816 28.6161 30.2103 29.8005 30.6919 31.247C30.7037 31.2824 30.7155 31.318 30.7274 31.3537L28.8301 31.9861C28.3285 30.4813 28.0837 29.7602 27.1226 28.9246C26.0553 27.9966 25.0508 27.6699 23.7788 27.6699H16.2788Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.9c34d98e354fbd090848f8417f4825ee.svg";
export { ForwardRef as ReactComponent };